// extracted by mini-css-extract-plugin
export default {"marked":"style_marked__krCMg","noApproval":"style_noApproval__64Tj7"};